// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizingResult = objectOf({
  is_personalizing: boolean,
  days_until_personalizing: maybe(number, true),
  message: maybe(string, true),
});
